/**
 * Textos compartilhados dos cadeados por plano (FeatureLockBanner,
 * PlanUpgradeModal, usePlanLock). Nome do plano como aparece no card de
 * planos (system_subscription_plans.name).
 */
export const PROFESSIONAL_PLAN_NAME = 'Profissional';
export const BUSINESS_PLAN_NAME = 'Business';

/**
 * "está disponível a partir do plano Profissional" | "está disponível no plano Business".
 * Com `plural` (nome da feature no plural, ex.: "Pacotes de serviços" ou
 * "A pesquisa ... e o convite ..."): "estão disponíveis ...".
 */
export const planAvailabilityText = (planName, plural = false) => {
  const verb = plural ? 'estão disponíveis' : 'está disponível';
  return planName === BUSINESS_PLAN_NAME
    ? `${verb} no plano ${BUSINESS_PLAN_NAME}`
    : `${verb} a partir do plano ${planName}`;
};

/** "1 agenda" | "2 agendas" */
export const countLabel = (count, one, many) => `${count} ${count === 1 ? one : many}`;

/** Quem dá o limite: "O plano Essencial" | "O período de teste" | "Seu plano" (sem nome conhecido). */
export const planOwnerLabel = ({ planName, inTrial }) => {
  if (inTrial) return 'O período de teste';
  return planName ? `O plano ${planName}` : 'Seu plano';
};

/**
 * Frase única de limite estourado (agenda, usuário, sala, procedimento):
 * "O plano Essencial permite até 1 agenda". Quem chama completa com o que
 * fazer ("Mude de plano para adicionar mais.").
 */
export const planLimitText = (owner, limit, one, many) => `${owner} permite até ${countLabel(limit, one, many)}`;

/** Complemento padrão do limite estourado, com o atalho de troca de plano ao lado. */
export const LIMIT_UPGRADE_HINT = 'Mude de plano para adicionar mais.';

/**
 * O que fazer no limite de um cadastro (agenda, sala, procedimento), igual ao texto
 * do servidor. `feminine`: agenda e sala; `reactivate`: reativar um item inativo.
 * "Para cadastrar outra, inative uma ou mude de plano." |
 * "Para reativar este, inative outro ou mude de plano."
 */
export const limitActionHint = (feminine, reactivate = false) => {
  if (reactivate) {
    return feminine
      ? 'Para reativar esta, inative outra ou mude de plano.'
      : 'Para reativar este, inative outro ou mude de plano.';
  }
  return feminine
    ? 'Para cadastrar outra, inative uma ou mude de plano.'
    : 'Para cadastrar outro, inative um ou mude de plano.';
};

/** Mesmo papel de limitActionHint para usuários (CompanyUserSeats.php). */
export const USER_LIMIT_HINT = 'Para convidar mais alguém, remova um acesso ou mude de plano.';
export const USER_REACTIVATE_LIMIT_HINT = 'Para devolver este acesso, remova outro ou mude de plano.';

/** Rótulo único do atalho de troca de plano nos avisos de limite. */
export const LIMIT_UPGRADE_BUTTON = 'Fazer upgrade';
